import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/lib/api";

/**
 * JourneyPill — compact one-line entry point on the main dashboard.
 * Shows the athlete's current rank + training-day count, and invites
 * them to visit the full /journey page. Replaces the stacked accountability
 * cards that were making the dashboard feel overwhelming.
 */
export const JourneyPill = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${API}/athlete/journey`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then(setData)
      .catch(() => {});
  }, []);

  if (!data) return null;

  const nextRankHint = data.next_rank
    ? `${data.next_rank.days_needed} to ${data.next_rank.label}`
    : "Top rank unlocked";

  return (
    <Link
      to="/journey"
      className="group block bg-surface border border-border hover:border-primary/40 rounded-xl px-4 py-3 sm:px-5 sm:py-4 transition-colors"
      data-testid="journey-pill"
    >
      <div className="flex items-center gap-3">
        <span className="text-2xl sm:text-3xl flex-shrink-0" aria-hidden>
          {data.rank.emoji}
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-baseline gap-2 flex-wrap">
            <p className="font-heading text-base sm:text-lg font-bold text-white truncate">
              {data.rank.label}
            </p>
            <span className="text-xs text-text-secondary">
              · {data.distinct_training_days} training day{data.distinct_training_days === 1 ? "" : "s"}
            </span>
          </div>
          <p className="text-xs text-text-muted mt-0.5 truncate">{nextRankHint}</p>
        </div>
        <ArrowUpRight className="w-4 h-4 text-text-muted group-hover:text-primary transition-colors flex-shrink-0" />
      </div>
    </Link>
  );
};

export default JourneyPill;
